import { defineComponent as _defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue';
import { makeFormModel, submitForm, toDataModel } from '../form/helpers';
import { otpField } from '../form/models/commonFields';
import { FormEvent, FormDefinition } from '../form/interfaces';
import { Observable } from 'rxjs';
import { otpMessage } from 'ah-common-lib/src/helpers/otp';
import { PropType, ref, reactive, computed } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { ValidatedForm } from 'ah-common-lib/src/form/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'OtpModalComponent',
  props: {
  otpPhone: {
    type: String,
  },
  staticOTP: {
    type: Boolean,
    default: false,
  },
  request: {
    type: Function as PropType<(otp: string) => Observable<any>>,
    required: true,
  },
  refreshOtpRequest: {
    type: Function as PropType<() => Observable<any>>,
    required: true,
  },
  otpErrorCheck: {
    type: Function as PropType<(error: any) => boolean>,
    required: true,
  },
},
  emits: {
  cancel: () => true,
  completed: (_result: any) => true,
  error: (_error: any) => true,
},
  setup(__props, { expose, emit }) {

const props = __props;





const otpFormDef = reactive<FormDefinition>({
  form: makeFormModel({
    name: 'otpForm',
    title: 'OTP',
    fieldType: 'form',
    fields: [otpField('otp', '', { hideErrors: true })],
  }),
  validation: null,
});

const modal = ref<InstanceType<typeof BModal>>();

const requestManager = useRequestManager({
  exposeToParent: ['refreshOtp'],
  onRetryFromParentManager: (k: string) => {
    if (k === 'refreshOtp') {
      refreshOtp();
    }
  },
}).manager;

const otpError = ref<boolean>(false);

const isInvalidForm = computed(() => !!otpFormDef.validation?.$invalid);

function show() {
  refreshOtp();
  modal.value?.show();
}

function cancel() {
  emit('cancel');
}

function refreshOtp() {
  requestManager.currentOrNew('refreshOtp', props.refreshOtpRequest()).subscribe(() => {
    otpError.value = false;
    otpFormDef.form.otp = [];
  });
}

function triggerRequest() {
  if (otpFormDef.validation) {
    submitForm(otpFormDef.validation);
  }

  if (otpFormDef.validation?.$invalid) {
    return;
  }
  const otp: string = toDataModel(otpFormDef.form).otp;

  requestManager.cancelAndNew('otpSubmit', props.request(otp)).subscribe(
    (result) => {
      emit('completed', result);
    },
    (error) => {
      if (props.otpErrorCheck(error)) {
        otpError.value = true;
      } else {
        emit('error', error);
      }
    }
  );
}

function onFormEvent(event: FormEvent) {
  if (event.event === 'form-field-submit') {
    triggerRequest();
  }
}

expose({ show: show });

return { __sfc: true,props, emit, otpFormDef, modal, requestManager, otpError, isInvalidForm, show, cancel, refreshOtp, triggerRequest, onFormEvent, BModal, otpMessage, ValidatedForm }
}

})